import React from "react";

const AboutPage = () => {
  return (
    <div className="container py-5" style={{ fontFamily: "'Poppins', sans-serif" }}>
      <div className="text-center mb-5">
        <h2 className="fw-bold text-primary">Sobre Nosotros</h2>
        <p className="text-muted lead">
          Conoce más acerca de Market Luz y nuestro compromiso contigo.
        </p>
      </div>

      <div className="row g-5">
        {/* Misión */}
        <div className="col-md-6">
          <div className="card shadow-sm border-0 rounded-4 p-4 h-100">
            <h4 className="fw-semibold text-success mb-3">
              <i className="bi bi-bullseye me-2"></i> Nuestra Misión
            </h4>
            <p className="text-muted">
              En <strong>Market Luz</strong>, creemos en hacer la vida más sencilla 
              a través de un solo lugar donde encuentres todo lo que necesitas. 
              Nos esforzamos por ofrecer productos de calidad, un servicio confiable 
              y una experiencia de compra moderna y segura.
            </p>
          </div>
        </div>

        {/* Visión */}
        <div className="col-md-6">
          <div className="card shadow-sm border-0 rounded-4 p-4 h-100">
            <h4 className="fw-semibold text-info mb-3">
              <i className="bi bi-eye me-2"></i> Nuestra Visión
            </h4>
            <p className="text-muted">
              Aspiramos a convertirnos en el ecommerce de confianza para todas 
              las familias, ofreciendo no solo productos, sino también 
              experiencias de valor que faciliten el día a día de nuestros clientes.
            </p>
          </div>
        </div>
      </div>

      {/* Valores */}
      <div className="mt-5">
        <h4 className="fw-bold text-center mb-4">Nuestros Valores</h4>
        <div className="row g-4">
          <div className="col-md-4">
            <div className="card border-0 shadow-sm rounded-4 p-3 h-100 text-center">
              <i className="bi bi-star-fill text-primary fs-2 mb-2"></i>
              <h5 className="fw-semibold text-primary">Calidad</h5>
              <p className="text-muted small">
                Cada producto es cuidadosamente seleccionado para asegurar que 
                cumpla con nuestros altos estándares de calidad.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow-sm rounded-4 p-3 h-100 text-center">
              <i className="bi bi-shield-check text-success fs-2 mb-2"></i>
              <h5 className="fw-semibold text-success">Confianza</h5>
              <p className="text-muted small">
                Nuestro equipo trabaja con transparencia y responsabilidad 
                para ganarnos tu confianza en cada compra.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="card border-0 shadow-sm rounded-4 p-3 h-100 text-center">
              <i className="bi bi-lightning-charge-fill text-warning fs-2 mb-2"></i>
              <h5 className="fw-semibold text-warning">Innovación</h5>
              <p className="text-muted small">
                Buscamos siempre mejorar la experiencia de compra con 
                tecnología y diseño moderno.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
